export class Notification {
    public type = '';
    public data;

    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
}